/**
 * @packageDocumentation
 * @module Utils
 */
import debug from 'debug';
/**
 * Colours to use for different log types
 */
var COLOURS = {
    trace: 'green',
    info: 'blue',
    warn: 'darkkhaki',
    error: 'red',
};
/**
 * Function to use instead of `console.log`.
 *
 * It will print the logs in different colors and with more control
 */
var Logger = /** @class */ (function () {
    function Logger() {
        var _this = this;
        /**
         * Namespace to use as identified in the `console.log` and also in the `localStorage`
         */
        this.baseNamespace = 'baseLogger';
        /**
         * Function to set the base namespace to use in the localstorage
         * @param baseNamespace string to use as namespace
         */
        // eslint-disable-next-line no-return-assign
        this.setBaseNamespace = function (baseNamespace) { return _this.baseNamespace = baseNamespace; };
        /**
         * Function to get the base namespace to use in the localstorage
         */
        this.getBaseNamespace = function () {
            var debugLocalStorage = localStorage.getItem('debug');
            if (debugLocalStorage)
                return debugLocalStorage.replace(':*', '');
            return undefined;
        };
        /**
         * Function to set the source context
         * @param source string to use as source
         */
        // eslint-disable-next-line no-return-assign
        this.setSource = function (source) { return _this.source = source; };
    }
    /**
     * Function to log the message to the console
     * @param level type of message to log
     * @param message the message to print
     * @param source the source related to the log message, Optional
     */
    Logger.prototype.generateMessage = function (level, message, source) {
        // Set the prefix which will cause debug to enable the message
        var namespace = this.getBaseNamespace() + ":" + level;
        var createDebug = debug(namespace);
        // Set the colour of the message based on the level
        createDebug.color = COLOURS[level];
        if (source) {
            createDebug(source, message);
        }
        else if (this.source) {
            createDebug(this.source, message);
        }
        else {
            createDebug('', message);
        }
    };
    /**
     * Function to enable the logger
     */
    Logger.prototype.enable = function () {
        localStorage.setItem('debug', this.baseNamespace + ":*");
        setTimeout(function () { window.location.reload(); }, 0);
    };
    /**
     * Function to disable the logger
     */
    // eslint-disable-next-line class-methods-use-this
    Logger.prototype.disable = function () {
        localStorage.removeItem('debug');
        setTimeout(function () { window.location.reload(); }, 0);
    };
    /**
     * Function to create a trace log
     * @param message message to log
     * @param source the source related to the log message, Optional
     */
    Logger.prototype.trace = function (message, source) {
        return this.generateMessage('trace', message, source);
    };
    /**
     * Function to create an information log
     * @param message message to log
     * @param source the source related to the log message, Optional
     */
    Logger.prototype.info = function (message, source) {
        return this.generateMessage('info', message, source);
    };
    /**
     * Function to create a warning log
     * @param message message to log
     * @param source the source related to the log message, Optional
     */
    Logger.prototype.warn = function (message, source) {
        return this.generateMessage('warn', message, source);
    };
    /**
     * Function to create an error log
     * @param message message to log
     * @param source the source related to the log message, Optional
     */
    Logger.prototype.error = function (message, source) {
        var stack = source || new Error().stack;
        return this.generateMessage('error', message, stack);
    };
    return Logger;
}());
export { Logger };
export default new Logger();
//# sourceMappingURL=Logger.js.map